// test467
(467 && 0);
